{
    "UserMenu_Notifications": "Notificações",
    "UserMenu_UserTour": "Iniciar tour de educação do utilizador",
    "UserMenu_ShowInsights": "Mostrar painel de insights",
    "UserMenu_HideInsights": "Ocultar painel de insights",
    "UserMenu_ChangePassword": "Alterar a palavra-passe",
    "UserMenu_ChangeLanguage": "Alterar idioma",
    "UserMenu_Timezone": "Alterar fuso horário",
    "UserMenu_Help": "Ajuda",
    "UserMenu_ClearContentful": "Limpar cache de conteúdo",
    "UserMenu_ChangeBrowserProfile": "Alterar perfil do browser",
    "UserMenu_Resources": "Recursos",
    "UserMenu_Resources_Terms": "Termos e Condições",
    "UserMenu_Resources_CookiePolicy": "Política de Cookies",
    "UserMenu_Resources_PrivacyPolicy": "política de Privacidade",
    "UserMenu_Logout": "Sair",
    "NAME": "UserMenu"
}